export function ErrorMessage(props: { errorMessage: string | undefined }) {
  return <div className='mt-2 min-h-5 text-sm text-red-500'>{props.errorMessage}</div>
}
